import axios from 'axios';
import { find } from 'lodash';

export default {
    namespaced: true,
    state: {
        all: [],
    },
    getters: {
        getAll(state) {
            return state.all;
        },
        getById: (state) => (id) => {
            return find(state.all, lid => {
                return lid.id === id;
            });
        },
        getLidsByFlangeSize: (state) => (flangeSize) => {
            let allMatchedLids = _.filter(state.all, lid => {
                return lid.flange_size === flangeSize;
            })

            if (allMatchedLids) {
                return allMatchedLids;
            }
        }
    },
    actions: {
        index({commit}) {
            return axios.get(process.env.VUE_APP_API_URL + 'lids')
                    .then(({data}) => {
                        commit('setLids', data);
                    });
        },
    },
    mutations: {
        setLids(state, lids) {
            state.all = lids;
        },
    },
};
